import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Radio.module.css'
import styleNames from '../../utils/styleNames'

export default class Radio extends Component {
  static propTypes = {
    errorMessage: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string
  }

  static defaultProps = {
    checked: false
  }  

  constructor (props) {
    super(props)
    this.state = {
      checked: null
    }
  }
    
  _onChange (event) {
    this.setState({ checked: event.target.value })
    this.props.onChange(event.target.value)
  }

  render () {
    const { errorMessage, name, options, title } = this.props
    return (
      <div>
        <h2>{title}</h2>
        <div className={styles['radio-container']}>
          <div className={styleNames(styles, errorMessage === '' ? 'no-error' : 'has-error' + ' error')}>
            <div />
            <span>{errorMessage}</span>
          </div>        
          {options.map((option, i) => (
            <div key={name + i} className={styles['radio-button']}>
              <input
                checked={this.state.checked === option}
                id={name + i}
                name={name}
                onChange={this._onChange.bind(this)}
                type="radio"
                value={option}
              />
              <label htmlFor={name + i}>
                <div className={styles.indicator}/>
                <span className={styles['radio-text']}>{option}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    )
  }
}
